export default "__VITE_ASSET__C3quKds1__"